import { Button, Modal, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconRecordMail } from '@tabler/icons-react';

export const RECORDING_NOTICE_ACKNOWLEDGE_LABEL = 'I understand and join';
/** The label when the person is already in the call (recording resumed after they joined). */
export const RECORDING_NOTICE_MID_CALL_LABEL = 'I understand';

/**
 * Informational acknowledgment shown to a client or guest before they connect to a session that is
 * recording, and mid-call when the recorder joins the call after they did and they have not accepted
 * the notice in this page session (design Decision 39). Recording permission remains governed by the
 * existing FHIR Consent, checked when the provider's join creates the meeting; this does not create
 * or replace consent. `onDecline` adds a Leave button for anyone who does not want to continue.
 */
export function RecordingNoticeModal({
  opened,
  onAcknowledge,
  onDecline,
  acknowledgeLabel = RECORDING_NOTICE_ACKNOWLEDGE_LABEL,
}: {
  opened: boolean;
  onAcknowledge: () => void;
  onDecline?: () => void;
  acknowledgeLabel?: string;
}): JSX.Element {
  return (
    <Modal
      opened={opened}
      onClose={() => undefined}
      closeButtonProps={{ 'aria-label': 'Recording notice must be acknowledged' }}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      title="Recording notice"
    >
      <Stack align="center" gap="md">
        <ThemeIcon size={56} radius="xl" color="red" variant="light">
          <IconRecordMail size={28} />
        </ThemeIcon>
        <Text ta="center">This session is being recorded for clinical documentation.</Text>
        <Text size="sm" c="dimmed" ta="center">
          Select “{acknowledgeLabel}” to acknowledge that you have been informed.
        </Text>
        <Button color="red" fullWidth onClick={onAcknowledge}>
          {acknowledgeLabel}
        </Button>
        {onDecline ? (
          <Button variant="default" fullWidth onClick={onDecline}>
            Leave
          </Button>
        ) : null}
      </Stack>
    </Modal>
  );
}
